"use client"
import PropTypes from "prop-types"

const Numbers = ({ minimum = 0, maximum = 9, step = 1, currentVal = 0, description = "", onChange = () => {} }) => {
  const massive = [...Array((1 / step) * (maximum - minimum) + 1)].map(
    (el, index) => Math.round((minimum + index * step) * 10) / 10,
  )

  return (
    <div className="numbers">
      <span className="description">{description}</span>
      {massive.map((num) => (
        <span key={num} className={"number " + (num === currentVal ? "selected" : "")} onClick={() => onChange(num)}>
          {num}
        </span>
      ))}
    </div>
  )
}

Numbers.propTypes = {
  minimum: PropTypes.number,
  step: PropTypes.number,
  maximum: PropTypes.number,
  currentVal: PropTypes.number,
  description: PropTypes.string,
  onChange: PropTypes.func,
}

export default Numbers
